<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>

<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="15" y="105" rx="0" ry="0" width="345" height="98" />
        <rect x="14" y="222" rx="0" ry="0" width="108" height="81" />
        <rect x="135" y="223" rx="0" ry="0" width="223" height="29" />
        <rect x="136" y="260" rx="0" ry="0" width="129" height="20" />
        <rect x="136" y="285" rx="0" ry="0" width="52" height="19" />
        <rect x="16" y="65" rx="0" ry="0" width="40" height="28" />
        <rect x="66" y="67" rx="0" ry="0" width="32" height="22" />
        <rect x="15" y="15" rx="0" ry="0" width="345" height="36" />
        <rect x="307" y="29" rx="0" ry="0" width="1" height="1" />
        <rect x="111" y="67" rx="0" ry="0" width="32" height="22" />
        <rect x="153" y="67" rx="0" ry="0" width="32" height="22" />
        <rect x="197" y="67" rx="0" ry="0" width="32" height="22" />
        <rect x="240" y="67" rx="0" ry="0" width="32" height="22" />
        <rect x="283" y="66" rx="0" ry="0" width="32" height="22" />
        <rect x="327" y="66" rx="0" ry="0" width="32" height="22" />
        <rect x="14" y="319" rx="0" ry="0" width="108" height="81" />
        <rect x="135" y="320" rx="0" ry="0" width="223" height="29" />
        <rect x="136" y="357" rx="0" ry="0" width="129" height="20" />
        <rect x="136" y="382" rx="0" ry="0" width="52" height="19" />
        <rect x="15" y="416" rx="0" ry="0" width="108" height="81" />
        <rect x="136" y="417" rx="0" ry="0" width="223" height="29" />
        <rect x="137" y="454" rx="0" ry="0" width="129" height="20" />
        <rect x="137" y="479" rx="0" ry="0" width="52" height="19" />
        <rect x="15" y="512" rx="0" ry="0" width="108" height="81" />
        <rect x="136" y="513" rx="0" ry="0" width="223" height="29" />
        <rect x="137" y="550" rx="0" ry="0" width="129" height="20" />
        <rect x="137" y="575" rx="0" ry="0" width="52" height="19" />
    </content-loader>
</template>


// WEBPACK FOOTER //
// src/skeleton/listSkeleton.vue